"use client";
import { Button } from "@/components/ui/button";
import { CartContext } from "@/context/CartContext";
import { useShippingStore } from "@/store/Shipping";
import { useRouter } from "next/navigation";
import { useContext } from "react";

const BuyNow = ({ product }) => {
  const { addOrderProduct } = useContext(CartContext);
  const { setOrderFrom } = useShippingStore();

  const router = useRouter();

  const buyNowHandle = () => {
    addOrderProduct([product]);
    setOrderFrom("product");
    window.location.href = "/checkout";
    // router.push("/checkout");
  };

  return (
    <Button
      onClick={() => buyNowHandle()}
      className="flex items-center justify-center w-full border border-brand-sky bg-white text-brand-deep hover:bg-brand-sky hover:text-white font-semibold rounded-xl transition-colors"
    >
      Buy Now
    </Button>
  );
};

export default BuyNow;